import { useTranslation } from "react-i18next";
import { Col, Row, Form, Card } from "react-bootstrap";
import HeaderFields from "../../HeaderFields";
import { InlineInputField, Label } from "../../fields";
import TEMPLATES from "..";

const ProfileForm = ({ control, formState }) => {
  const { t } = useTranslation(["programs"]);
  return (
    <Row>
      <HeaderFields control={control} formState={formState} />
      <Col xs={12} className="mt-4">
        <Label>{t(($) => $.programs.templateForms["Profiling Rules"])}</Label>
      </Col>
      <Col xs={12}>
        <Card className="p-4">
          <Row>
            <Col xs={8}>
              <Row>
                <Col xs={12} className="mb-3">
                  <Form.Group>
                    <div className="d-flex align-items-center fs-standard">
                      <span className="text-nowrap">
                        {t(($) => $.programs.templateForms["Set an initial price of $"])}
                      </span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"initial.price"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12} className="mb-3">
                  <Form.Group>
                    <div className="d-flex align-items-center fs-standard">
                      <span className="text-nowrap">{t(($) => $.programs.templateForms["Every time I sell"])}</span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"increase.units"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">{t(($) => $.programs.templateForms["units in"])}</span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"increase.days"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">
                        {t(($) => $.programs.templateForms["days, increase my price"])}
                      </span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"increase.percent"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">%</span>
                    </div>
                  </Form.Group>
                </Col>
                <Col xs={12}>
                  <Form.Group>
                    <div className="d-flex align-items-center fs-standard">
                      <span className="text-nowrap">{t(($) => $.programs.templateForms["If I haven't sold"])}</span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"lower.units"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">{t(($) => $.programs.templateForms["units after"])}</span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"lower.days"}
                          control={control}
                          rules={{ required: true }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">
                        {t(($) => $.programs.templateForms["days, lower the price by"])}
                      </span>
                      <span style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                        <InlineInputField
                          fieldName={"lower.percent"}
                          control={control}
                          rules={{
                            required: true,
                            valueAsNumber: true,
                            validate: (value) => value > 0,
                          }}
                          placeholder={"..."}
                        />
                      </span>
                      <span className="text-nowrap">%</span>
                    </div>
                  </Form.Group>
                </Col>
              </Row>
            </Col>
            <Col xs={4}>
              <div
                className="fs-standard"
                style={{
                  padding: "2rem",
                  border: "1px solid #eee",
                  borderRadius: "6px",
                  backgroundColor: "#f8f8f8",
                  height: "100%",
                }}
              >
                {t(TEMPLATES.find((template) => template.id === "PROFILE").description)}
              </div>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export { ProfileForm };
